import { httpAuth2 } from "@/api/auth";

export type UnreadMessageCountResponse = {
  unread_count: number;
};

export const messagingRequestsTyped = {
  fetch_unread_message_count: function (): Promise<UnreadMessageCountResponse> {
    return httpAuth2
      .post("/v1/messaging/unread_message_count", {
        context: {
          exceptionConfig: { ForbiddenException: { allowRetry: false } },
          preventAllErrorToast: true,
          showLoader: false,
        },
      })
      .json<UnreadMessageCountResponse>();
  },
};
